import { css } from 'lit';

export const questionsDescription = css`

#question-description {
  display: block;
  font-size: var(--question-description-size, 2rem);
  line-height: 3rem;
  font-weight: 500;
  color: var(--question-description-color, var(--c-text-sec));
  position: relative;
}

.question-description{
  margin-block-start: var(--question-description-top-margin,1.5rem);
}
.question-description-top-margin{
  --question-description-top-margin: 4.5rem;
}
 .question-description--title {
  display: block;
  line-height: 3rem;
  font-weight: 500;
  color: var(--question-description-color, var(--c-text-sec));
  margin-block-start: 1.5rem;
  font-size: var(--question-description-size, 2.25rem);
  margin-block-end: 1rem;
}

:host-context(.additional-insured-mta) .question-description--title {
  line-height: 1.25;
  font-weight: 700;
  color: var(--c-font-title);
  margin-block-start: 0;
  font-size: var(--question-description-title-size, 3rem);
}`;